// extracted by mini-css-extract-plugin
module.exports = {"Menu":"zj_a zu_h","Menu__offsetParent":"zj_b zu_bj","Menu__trigger--shadowed":"zj_c"};